// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const deoxys_defense: PokeData = {
  "id": 10002,
  "name": "deoxys-defense",
  "height": 17,
  "weight": 608,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "wrap",
    "leer",
    "counter",
    "psychic",
    "teleport",
    "night-shade",
    "recover",
    "amnesia",
    "protect",
    "spikes",
    "mirror-coat",
    "knock-off",
    "skill-swap",
    "snatch",
    "iron-defense",
    "psycho-boost",
    "psycho-shift",
    "zen-headbutt"
  ],
  "moves": [
    "leer",
    "psychic",
    "night-shade",
    "protect",
    "snatch",
    "zen-headbutt",
    "healing-wish",
    "calm-mind",
    "psy-pulse",
    "prismatic-cage",
    "psychic-terrain",
    "psywave",
    "synchronize"
  ],
  "evolution_chain": {
    "id": 202,
    "item": null,
    "species": [
      {
        "name": "deoxys",
        "order": 416,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 158,
    "speed": 136,
    "ability_power": 106
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
